/**
 * Custom fix for Gift & Story (hmgiftstory.com)
 *
 * Problem: on personalized products, "Name to Personalize" / "Nickname"
 * text fields are rendered by the Easify Product Options app and are
 * NOT tied to the Shopify variant option ("Gift For"). If a customer
 * fills them in for one variant (e.g. Grandson) and then switches to a
 * different variant (e.g. Granddaughter) without manually clearing the
 * text fields, the stale text gets submitted to the cart together with
 * the new variant, producing a mismatched / wrong order.
 *
 * Fix: whenever a native Shopify option input (radio / checkbox / select)
 * inside the product form changes, clear any Easify personalization text
 * fields on the page so the customer is forced to re-enter the correct
 * text for the newly selected variant.
 *
 * Safe to load on every page: it does nothing unless both a product
 * option input and an Easify text field are present.
 */
(function () {
  'use strict';

  function setNativeValue(el, value) {
    var proto = Object.getPrototypeOf(el);
    var desc =
      Object.getOwnPropertyDescriptor(proto, 'value') ||
      Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value') ||
      (window.HTMLTextAreaElement && Object.getOwnPropertyDescriptor(window.HTMLTextAreaElement.prototype, 'value'));

    if (desc && desc.set) {
      desc.set.call(el, value);
    } else {
      el.value = value;
    }

    el.dispatchEvent(new Event('input', { bubbles: true }));
    el.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function clearPersonalizationFields() {
    var fields = document.querySelectorAll(
      '.po-textField-input, textarea.po-textField-input, [class*="po-textField-input"]'
    );
    fields.forEach(function (field) {
      if (field.value) {
        setNativeValue(field, '');
      }
    });
  }

  document.addEventListener(
    'change',
    function (event) {
      var target = event.target;
      if (!target || !target.tagName) return;

      var tag = target.tagName;
      var type = (target.type || '').toLowerCase();
      var isNativeOptionInput =
        (tag === 'INPUT' && (type === 'radio' || type === 'checkbox')) || tag === 'SELECT';
      if (!isNativeOptionInput) return;

      var withinProductForm = target.closest('.product-form__input, product-form, .product-form');
      if (!withinProductForm) return;

      setTimeout(clearPersonalizationFields, 50);
    },
    true
  );
})();